<template>
  <div class="gallery__item cursor-pointer" :class="{'gallery__item-current': isSelected}">
    <div class="gallery__thumbnail" @click="onClick">
      <div class="gallery__thumbnail-item">
        <component v-bind:is="getMediaComponent()" :key="model.id" class="w-100 h-100 border border-gray-200" :item="model"></component>
      </div>
    </div>
    <div class="mt-2 mb-2 d-block">
      <div v-if="getNameLength < maxNameLength" v-text="model.name"></div>
      <div v-else>
        <el-popover
            placement="top"
            width="200"
            trigger="hover"
            :content="model.name">
          <div slot="reference">{{ getShortName }} ...</div>
        </el-popover>
      </div>
    </div>
    <div class="gallery__thumbnail-footer d-flex">
      <a class="flex-fill" @click="onPreview">Preview</a>
      <a class="flex-fill" @click="onEdit" v-if="canEdit">Edit</a>
      <a class="flex-fill" @click="onDelete" v-if="canDelete">Remove</a>
    </div>
  </div>
</template>

<script>
import ImageComponent from "./types/image";
import VideoComponent from "./types/video";
import PdfComponent from "./types/pdf";

export default {
  components: {
    'image-component': ImageComponent,
    'video-component': VideoComponent,
    'pdf-component': PdfComponent,
  },

  props: {
    model: Object,
    isSelected: Boolean,
    deleteUrl: String,
    canDelete: Boolean,
    canEdit: Boolean,
    updateUrl: String,
  },

  data() {
    return {
      maxNameLength: 25,
    };
  },

  computed: {
    /**
     * @return {Number}
     */
    getNameLength() {
      return _.isString(this.model.name) ? this.model.name.length : 0;
    },

    /**
     * @return {String}
     */
    getShortName() {
      if (! _.isString(this.model.name)) {
        return null;
      }

      return this.model.name.substring(0, this.maxNameLength);
    },
  },

  methods: {
    /**
     * @event select
     */
    onClick() {
      if (!_.isNull(_.get(this.model, 'full_url'))) {
        this.$emit('select', this.model);
      }
    },

    /**
     * @event delete
     */
    onDelete() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {url: this.deleteUrl}))
          .catch(() => {
          });
    },

    /**
     * @event show-media-show-dialog
     */
    onPreview() {
      if (!_.isNull(_.get(this.model, 'full_url'))) {
        eventBus.$emit('show-media-show-dialog', {
          mimeType: _.get(this.model, 'mime_type'),
          url: _.get(this.model, 'full_url'),
        });
      }
    },

    /**
     * @event show-attachment-form-dialog
     */
    onEdit() {
      eventBus.$emit('show-attachment-form-dialog', {
        model: this.model,
        storeUrl: this.updateUrl,
      });
    },

    /**
     * @return {String}
     */
    getMediaComponent() {
      let mime =  _.get(this.model, 'mime_type');
      if (RegExp('^video\/', 'i').test(mime)) {
        return 'video-component';
      }

      if (RegExp('^application\/pdf', 'i').test(mime)) {
        return 'pdf-component';
      }

      return 'image-component';
    },
  },
}
</script>

<style scoped>

</style>
